import * as d3 from "d3";
import React, { useCallback, useRef } from "react";
import { styled } from "@mui/system";
import Canvas from "./Canvas";
var StyledRootContainer = styled("div")({
    height: "100%",
    width: "100%",
    position: "relative",
    cursor: "pointer",
});
export var get2DContext = function (canvas, options) {
    var dpi = window.devicePixelRatio || 1;
    var rect = canvas.getBoundingClientRect();
    canvas.width = Math.ceil(rect.width * dpi);
    canvas.height = Math.ceil(rect.height * dpi);
    var ctx = canvas.getContext("2d", options);
    ctx === null || ctx === void 0 ? void 0 : ctx.scale(dpi, dpi);
    return ctx;
};
export var ColorScale = React.memo(function (_a) {
    var arrayOfColors = _a.arrayOfColors, vertical = _a.vertical;
    var canvasRef = useRef(null);
    var drawCanvas = useCallback(function () {
        var canvas = canvasRef.current;
        if (!canvas) {
            return;
        }
        var ctx = get2DContext(canvas);
        if (!ctx) {
            return;
        }
        var height = canvas.getBoundingClientRect().height;
        var width = canvas.getBoundingClientRect().width;
        var max = vertical ? height : width;
        var pixelToColor = Array.isArray(arrayOfColors)
            ? function (pixel) {
                var scale = d3
                    .scaleQuantize()
                    .domain([0, max - 1])
                    .range(arrayOfColors);
                return scale(pixel);
            }
            : function (pixel) { return arrayOfColors(max > 1 ? pixel / (max - 1) : 0); };
        ctx.globalAlpha = 1;
        for (var pixel = 0; pixel < max; pixel++) {
            var color = pixelToColor(pixel);
            ctx.fillStyle = color;
            if (vertical) {
                ctx.fillRect(0, max - pixel, width, 2);
            }
            else {
                ctx.fillRect(pixel, 0, pixel + 1, height);
            }
        }
    }, [arrayOfColors, vertical]);
    return (React.createElement(StyledRootContainer, null,
        React.createElement(Canvas, { ref: canvasRef, drawCallback: drawCanvas })));
});
//# sourceMappingURL=ColorScale.js.map